module.exports = __webpack_public_path__ + "static/media/zcdt_xianshi@2x.5b10bff6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/zcdt_xianshi@2x.png
// module id = 1887
// module chunks = 0 1